import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { SharedModule } from '../../../shared/shared.module';
import { RoleService } from '../../../services/role.service';
import { Router } from '@angular/router';
import { AdvisorDashboardLayoutService } from '../../../pages/advisor-dashboard-layout/advisor-dashboard-layout.service';
import { CommonService } from '../../../services/common.service';
import { startRoleSwitch } from '../../../auth.config';

@Component({
  selector: 'app-change-roles-dialog',
  standalone: true,
  imports: [SharedModule],
  templateUrl: './change-roles-dialog.component.html',
  styleUrl: './change-roles-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChangeRolesDialogComponent {
  userRolesList: any = [];
  selectedUserRole: any = null;
  isShowCloseButton: boolean = false;
  prevSelectedUserRole: any = null;
  showPersonalDetailsPopup: boolean = false;
  constructor(
    private readonly ref: DynamicDialogRef,
    private readonly dialogService: DialogService,
    private readonly roleService: RoleService,
    private readonly router: Router,
    private readonly AdvisorDashboardLayoutService: AdvisorDashboardLayoutService,
    private readonly CommonService: CommonService,
  ){
    const profile = this.roleService.getRoles('profile');
    this.userRolesList = profile?.UserRoles.map((ele:any) => ({
      ...ele,
      UserRoleID: ele.UserRoleID,
      user_role: this.capitalizeFirstLetterOfEachWord(ele.UserRole),
     }));
    const selectedUSerRole = this.userRolesList.find((ele: any) => ele.UserRole === profile?.current_user_role);
    this.selectedUserRole = selectedUSerRole;
    this.prevSelectedUserRole = this.selectedUserRole;
    const data = this.dialogService.getInstance(this.ref!)?.data;
    this.isShowCloseButton = data?.isShowCloseButton;
  }
  capitalizeFirstLetterOfEachWord(role: string): string {
    if (!role) {
      return ' -- ';
    }
    return role
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }

  isEnableSubmitButton() {
    return this.selectedUserRole?.UserRole !== this.prevSelectedUserRole?.UserRole && this.selectedUserRole !== null;
  }
  closeDialog() {
    this.ref.close();
  }
  private resolveAdvisorId(profile: any): any {
    const advisorRole = profile?.UserRoles?.find(
      (r: any) => (r?.UserRole ?? '').toLowerCase() === 'advisor'
    );
    return (
      profile?.initialAdvisorID ??
      advisorRole?.AdvisorID ??
      profile?.AdvisorID ??
      null
    );
  }

  onUserRoleChange() {
    startRoleSwitch();

    const selectedRole = (this.selectedUserRole?.UserRole ?? '').toLowerCase();
    const role = [selectedRole];
    this.roleService.setRoles('roles', role);
    const profile = this.roleService.getRoles('profile');
    const advisorId = this.resolveAdvisorId(profile);

    profile['user_role'] = selectedRole;
    profile['current_user_role'] = selectedRole;
    profile['AdvisorIDs'] = advisorId ? [advisorId] : [];
    profile['AdvisorID'] = selectedRole === 'advisor' ? advisorId : null;
    if (role.includes('advisor')) {
      profile['advisor_azure_id'] = profile?.default_azure_id;
      profile['IsAdvisorDetailsUpdated'] = profile?.defaultIsAdvisorDetailsUpdated;
    }
    this.roleService.setRoles('profile', profile);

    if (role.includes('advisor assistant')) {
      localStorage.removeItem('assistantAdvisor');
      this.AdvisorDashboardLayoutService.getAssistantAdvisor(profile?.user_id, 'Y');
    } else {
      this.AdvisorDashboardLayoutService.clearAdvisorAssistantSession();
    }

    this.closeDialog();

    if (role.includes('admin')) {
      this.router.navigate(['/advisor-dashboard/user-management']);
      setTimeout(() => {
        this.CommonService.triggerAdvisorChanged();
      }, 100);
    } else if (role.includes('advisor')) {
      this.CommonService.getProductByAdvisorId(advisorId);
    }
  }
}
